export var createRenderer = function () {
    return function (options) {
        var _a;
        if (options && ((_a = options === null || options === void 0 ? void 0 : options.configuration) === null || _a === void 0 ? void 0 : _a.loadOnEvent)) {
            var onBssConnectorInit = function () {
                this.init(options);
            };
            document.addEventListener(options.configuration.loadOnEvent, onBssConnectorInit);
        }
        else {
            return this.init(options);
        }
    };
};
